import React from 'react';
import PropTypes from 'prop-types';
import { LeftNavigationBar, DashboardNavigationLink } from '@unite-us/app-components';
import { withRouter } from 'react-router';
import { AUTHORIZATION_STATUSES } from 'common/Status/authorizationConstants';
import { useCurrentPayerId } from 'common/contexts/CurrentProviderContext';
import { useFeatureFlag } from 'common/hooks';
import { useServiceAuthorizationStatusCount } from '../hooks/useServiceAuthorizationStatusCount';

export const StatusSelectBar = ({ router }) => {
  const payerId = useCurrentPayerId();
  const openCount = useServiceAuthorizationStatusCount(AUTHORIZATION_STATUSES.open, payerId);
  const updateEditAuthorizationsFeatureEnabled = useFeatureFlag('pays-5650-update-edit-authorizations');
  return (
    <LeftNavigationBar className="space-y-1 -mb-20">
      <DashboardNavigationLink
        className="text-base"
        label="Open"
        count={openCount}
        to="/authorizations/open"
        isActive={router && router.isActive({ pathname: '/authorizations/open' })}
      />
      <DashboardNavigationLink
        className="text-base"
        label="Accepted"
        to="/authorizations/accepted"
        isActive={router && router.isActive({ pathname: '/authorizations/accepted' })}
      />
      {updateEditAuthorizationsFeatureEnabled && (
        <DashboardNavigationLink
          className="text-base"
          label="Voided"
          to="/authorizations/voided"
          isActive={router && router.isActive({ pathname: '/authorizations/voided' })}
        />
      )}
      <DashboardNavigationLink
        className="text-base"
        label="Rejected"
        to="/authorizations/rejected"
        isActive={router && router.isActive({ pathname: '/authorizations/rejected' })}
      />
      <DashboardNavigationLink
        className="text-base"
        label="All Requests"
        to="/authorizations/all"
        isActive={router && router.isActive({ pathname: '/authorizations/all' })}
      />
    </LeftNavigationBar>
  );
};

StatusSelectBar.propTypes = {
  router: PropTypes.shape({
    isActive: PropTypes.func,
  }).isRequired,
};

export default withRouter(StatusSelectBar);
